/**
 * URL Auth0 should redirect to after /v2/logout.
 * Must exactly match an entry in Auth0 → Application → Allowed Logout URLs
 * (typically your app origin, which will then trigger login redirect).
 */
export function getAuth0LogoutReturnTo(): string {
  const explicit = import.meta.env.VITE_AUTH0_LOGOUT_RETURN_TO;
  if (typeof explicit === 'string' && explicit.trim()) {
    return explicit.trim();
  }
  return window.location.origin;
}

const DEFAULT_IDLE_TIMEOUT_MS = 60 * 60 * 1000;

/**
 * Client-side inactivity timeout. Should match Auth0 idle session / refresh token settings.
 */
export function getAuth0IdleTimeoutMs(): number {
  const raw = import.meta.env.VITE_AUTH0_IDLE_TIMEOUT_MS;
  if (typeof raw === 'string' && raw.trim()) {
    const parsed = Number.parseInt(raw.trim(), 10);
    if (Number.isFinite(parsed) && parsed > 0) {
      return parsed;
    }
  }
  return DEFAULT_IDLE_TIMEOUT_MS;
}
